import { Button, Form } from "react-bootstrap";
import UserActionPagesTemplate from "../../Template/UserActionPagesTemplate";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { SET_MESSAGE } from "../../Actions/Types";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { forgetPasswordService } from "../../Services/UserAction/ForgotPasswordService";
import aioaLogo from "../../Assets/img/all-in-one-accessibility-logo.svg";
import aioaLogoLight from "../../Assets/img/all-in-one-accessibility-logo-light.svg";
import { useTheme } from "../../Context/ThemeContext";

// component to render Forgot password page
const ForgotPasswordPage = () => {
  // Functions
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const emailRef = useRef<HTMLInputElement | null>(null);
  const {theme} = useTheme()

  //Get app parameter
  const app = searchParams.get("app");

  // Redux store
  const { user } = useSelector((store: StoreProptypes) => store);

  // State
  const [userEmail, setUserEmail] = useState<string>("");

  // navigate if user found
  useEffect(() => {
    if (user) {
      dispatch({
        type: SET_MESSAGE,
        payload: {
          toast_message: t(
            "You're already logged In. You can change your password via profile settings.",
            { returnObjects: true }
          ),
          toast_type: "success",
          onclose: null,
        },
      });

      navigate("/front/edit-profile/");
    }
  }, [user]);

  // function to focus on email input
  const handleFocus = () => {
    //console.log("handle Close called");
    if (emailRef && emailRef.current) {
      emailRef.current.focus();
    }
  };

  // function to handle form submission
  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    // check if user email is not available
    if (userEmail === "") {
      handleFocus();
      // dispatch enter email message
      dispatch({
        type: SET_MESSAGE,
        payload: {
          toast_message: t("Please enter your email address", {
            returnObjects: true,
          }),
          toast_type: "danger",
          onclose: null,
        },
      });
    }
    // check if user email is not valid
    else if (
      new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(userEmail) ===
      false
    ) {
      handleFocus();
      // dispatch invalid email message
      dispatch({
        type: SET_MESSAGE,
        payload: {
          toast_message: t("Please enter valid email address", {
            returnObjects: true,
          }),
          toast_type: "danger",
          onclose: null,
        },
      });
    } else {
      // check if user email is available
      if (userEmail) {
        // service to handle forget password API
        forgetPasswordService(userEmail, handleFocus, t, dispatch, navigate);
      }
    }
  };

  return (
    <>
      <UserActionPagesTemplate>
        <div className="aioa_dashboard-header-domain-wrapper mb-2 w-75 m-auto mt-5">
            <img src={aioaLogo} alt="All in One Accessibility Logo" />
        </div>
        <h1 className="mt-5">{t("forgot password label")}</h1>
        <Form>
          <Form.Group className="form-group mt-5" controlId="user_email">
            <Form.Label>{t("form email filed label")}</Form.Label>
            <Form.Control
              type="email"
              size="lg"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setUserEmail(e.target.value)
              }
              value={userEmail}
              aria-required="true"
              autoComplete="email"
              ref={emailRef}
            />
          </Form.Group>
          <Button
            variant="primary"
            type="submit"
            size="lg"
            className="w-100 submit-btn"
            onClick={(e) => handleSubmit(e)}
          >
            {t("Forgot Password")}
          </Button>
        </Form>
        <div className="aioa_dashboard-login-link">
          <Link
            to={`/front/login?logout=true${
              app && app === "readwritemadesimple"
                ? "&app=readwritemadesimple"
                : ""
            }`}
            className="aioa_free-trial-link"
          >
            {t("Login")}
          </Link>
        </div>
      </UserActionPagesTemplate>
    </>
  );
};

export default ForgotPasswordPage;
